import { Fragment } from "react";
import Attachment from "./Attachments";

const View = ({ document, title }) => {
    return (
        <Fragment>
            {document && (
                <div>
                    {document.attachments &&
                        document.attachments.length > 0 &&
                        document.attachments.map((m, i) => (
                            <Attachment
                                key={i}
                                no={i}
                                attachment={m}
                                title={title}
                            ></Attachment>
                        ))}
                </div>
            )}
        </Fragment>
    );
};

export default View;
